module.exports = __webpack_public_path__ + "img/jiantou.e8c4682f.png";